var Kindle = {
  isKindle: navigator.userAgent.indexOf("AppleWebKit/534.26+") != -1,
  init: function() {
    console.info("Init Kindle", Kindle.isKindle)
    if (Kindle.isKindle) {
      document.singleWindowMode = true;
      this.overrideConsole();
    } else {
      this.refreshScreen = function() {}
    }


    if (document.readyState === 'loading') {
      document.addEventListener("DOMContentLoaded", Kindle.setupBody);
    } else {
      Kindle.setupBody()
    } 
  },
  setupBody: function() {
    if (Kindle.isKindle) {
      document.documentElement.classList.add("kindle")
      Kindle.adjustBodyHeight();
    }
    Kindle.scaleFontToWindow();
  },
  scaleFontToWindow: function() {
    var size = Math.max(18,Math.min(48,Math.round(Math.min(window.outerWidth,window.outerHeight) / 25)))
    // document.body.style.fontSize = size + "px";

    var styleSheet = document.createElement("style")
    styleSheet.type = "text/css"
    styleSheet.innerText = 'body, select {font-size:' + size + 'px;}'
    styleSheet.innerText += '.kindle-fullheight {height:' + (window.outerHeight - 1) + 'px;}';
    document.head.appendChild(styleSheet)
  },
  adjustBodyHeight: function() {
    var width = window.innerWidth;
    if (width > 100) document.body.style.width = window.innerWidth;
    document.documentElement.style.minHeight = (window.outerHeight - 1) + 'px';
  },

  // Convenience function for inverting screen
  flashTimeout: null,
  flashTime: undefined,
  flashUpdateCount: 5,
  flashTriggerCount: 5,
  flashDuration: 300,
  refreshScreen: function(flashImmediately) {
    if (this.flashUpdateCount >= this.flashTriggerCount) {
      flashImmediately = true;
    }
    if (flashImmediately) {
      if (this.flashTimeout) clearTimeout(this.flashTimeout);
      document.documentElement.classList.add("inverted");
      this.flashUpdateCount = 0;
      this.flashTimeout = setTimeout(function () {
        document.documentElement.classList.remove("inverted");
        this.flashTimeout = null;
      }, this.flashDuration);
    } else {
      this.flashUpdateCount++
    }
  },
  overrideConsole: function() {
    console.error = window.onerror = function(message, source, lineno, colno, error) { 
      if (source != "undefined") message += " - " + source;
      if (lineno) message += ":" + lineno;
      var stack = new Error().stack
      Kindle.showMessage("! " + message)
    }

    console.log = function(message) { 
      var args = Array.prototype.slice.call(arguments);
      Kindle.showMessage("> " + args.join(" "))
    }

    if (Kindle.debug) {
      console.debug = console.log;
    }
  },
  messageTimeout: null,

  // Override console log for devices without an accessible log
  showMessage: function(message) {
    var el = document.querySelector('#kindle-console');
    if (!document.body) {
        // if (message) alert(message)      
    } else if (!el) {
      el = document.createElement('div');
      el.id = "kindle-console";
      document.body.appendChild(el)
      el.onclick = function(e) {
        el.parentNode.removeChild(el);
        Kindle.refreshScreen(true);
        Kindle.messageTimeout = null;
      }
    }
    if (el) {
      var msg = document.createElement('div');
      var timestamp = new Date().toLocaleTimeString();
      msg.appendChild(document.createTextNode(timestamp + " " + message));
      el.insertBefore(msg, el.children[0]);

      if (Kindle.messageTimeout) clearTimeout(Kindle.messageTimeout);
      Kindle.messageTimeout = setTimeout(function () {
        el.parentNode.removeChild(el);
        Kindle.messageTimeout = null;
      }, 10000);
    } else {
      setTimeout(function() {
        Kindle.showMessage(message);
      }, 1000)
    }
  },
}

Kindle.init();

if (module) module.exports = Kindle;
